import TextField from '@fhnw/components/Form/TextField/TextField';
import { useIntl, defineMessages } from 'react-intl';

interface SearchInputProps {
  value: string;
  onChange: (value: string) => void;
}

const messages = defineMessages({
  search: {
    id: 'Search Term',
    defaultMessage: 'Search',
  },
});

const SearchInput = ({ value, onChange }: SearchInputProps) => {
  const intl = useIntl();
  return (
    <TextField
      type="search"
      placeholder={intl.formatMessage(messages.search)}
      value={value}
      onChange={onChange}
    />
  );
};

export default SearchInput;
